<ng-container *ngIf="paddocks && property">
<form class="space-y-4" [formGroup]="form">

  <ng-container *ngIf="multi; else singleSelect">
    <!-- Property Selection Section -->
    <div class="bg-white rounded-md shadow-sm border border-gray-100 p-4">
      <div class="flex items-center space-x-2 mb-3">
        <div class="w-6 h-6 bg-blue-100 rounded-md flex items-center justify-center">
          <i class="fas fa-map-marker-alt text-blue-600 text-sm"></i>
        </div>
        <h3 class="text-sm font-semibold text-gray-900">Property</h3>
      </div>
      <div class="border-t border-gray-50 pt-3">
        <mat-checkbox formControlName="property" class="text-sm text-gray-700">
          <span class="ml-2 font-medium">{{ property.name }}</span>
        </mat-checkbox>
      </div>
    </div>

    <!-- Paddocks Selection Section -->
    <div class="bg-white rounded-md shadow-sm border border-gray-100 p-4">
      <div class="flex items-center space-x-2 mb-3">
        <div class="w-6 h-6 bg-green-100 rounded-md flex items-center justify-center">
          <i class="fas fa-layer-group text-green-600 text-sm"></i>
        </div>
        <h3 class="text-sm font-semibold text-gray-900">Paddocks</h3>
      </div>
      <div class="border-t border-gray-50 pt-3">
        <div class="grid grid-cols-1 gap-2">
          <div *ngFor="let item of paddocks; let i = index" formGroupName="paddocks" class="flex items-center">
            <mat-checkbox formControlName="{{i}}" class="text-sm text-gray-700">
              <span class="ml-2">{{ item.name }}</span>
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <ng-template #singleSelect>
    <mat-radio-group [formControl]="selectedTargetControl" aria-label="Select an option" class="space-y-4">
      
      <!-- Property Selection Section -->
      <div class="bg-white rounded-md shadow-sm border border-gray-100 p-4">
        <div class="flex items-center space-x-2 mb-3">
          <div class="w-6 h-6 bg-blue-100 rounded-md flex items-center justify-center">
            <i class="fas fa-map-marker-alt text-blue-600 text-sm"></i>
          </div>
          <h3 class="text-sm font-semibold text-gray-900">Property</h3>
        </div>
        <div class="border-t border-gray-50 pt-3">
          <mat-radio-button [checked]="true" [value]="property" class="text-sm text-gray-700">
            <span class="ml-2 font-medium">{{ property.name }}</span>
          </mat-radio-button>
        </div>
      </div>

      <!-- Paddocks Selection Section -->
      <div class="bg-white rounded-md shadow-sm border border-gray-100 p-4">
        <div class="flex items-center space-x-2 mb-3">
          <div class="w-6 h-6 bg-green-100 rounded-md flex items-center justify-center">
            <i class="fas fa-layer-group text-green-600 text-sm"></i>
          </div>
          <h3 class="text-sm font-semibold text-gray-900">Paddocks</h3>
        </div>
        <div class="border-t border-gray-50 pt-3">
          <div class="grid grid-cols-1 gap-2">
            <mat-radio-button *ngFor="let item of paddocks; let i = index" [value]="item" class="text-sm text-gray-700">
              <span class="ml-2">{{ item.name }}</span>
            </mat-radio-button>
          </div>
        </div>
      </div>
    </mat-radio-group>
  </ng-template>

  <!-- Details Section -->
  <div class="bg-white rounded-md shadow-sm border border-gray-100">
    <mat-expansion-panel [expanded]="true" class="border-0 shadow-none">
      <mat-expansion-panel-header class="px-4 py-3">
        <mat-panel-title class="flex items-center space-x-2">
          <div class="w-6 h-6 bg-purple-100 rounded-md flex items-center justify-center">
            <i class="fas fa-info-circle text-purple-600 text-sm"></i>
          </div>
          <span class="text-sm font-semibold text-gray-900">Details</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="px-4 pb-4">
        <ng-content></ng-content>
      </div>
    </mat-expansion-panel>
  </div>

  <!-- Action Buttons -->
  <div class="flex justify-center pt-3">
    <button 
      (click)="onClick()" 
      [disabled]="!form.valid" 
      class="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium py-2.5 px-6 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center space-x-2 text-sm"
    >
      <i class="fas fa-play text-xs"></i>
      <span>Run Report</span>
    </button>
  </div>

  <!-- Error Message -->
  <div *ngIf="form.errors?.['atLeastOneSelected']" class="bg-red-50 border border-red-200 rounded-md p-3">
    <div class="flex items-center space-x-2">
      <i class="fas fa-exclamation-triangle text-red-500 text-sm"></i>
      <span class="text-red-700 font-medium text-sm">This report requires at least one paddock or property to be selected.</span>
    </div>
  </div>
</form>
</ng-container>
